import customAxios from "../serverCall";


const getVerificationBadgeRequests = async (body) => {
  const response = await customAxios.post(
    `/admin/verificationbadge`,
    body
  );

  return response;
};

const approveRejectVerificationBadge = async (body) => {
  const response = await customAxios.post(
    `/admin/verificationbadge/approvereject`,
    body
  );

  return response;
};

const manageVerificationBadge = async (body) => {
  const response = await customAxios.post(
    `/admin/verificationbadge/manage`,
    body
  );

  return response;
};



const getVerifiedBadgeSettings = async (settingsId = null) => {
  const url = settingsId 
    ? `/admin/verified-badge/settings/${settingsId}`
    : `/admin/verified-badge/settings`;
  const response = await customAxios.get(url);
  return response;
};

const createVerifiedBadgeSettings = async (body) => {
  const createData = {
    coins_per_month: body.coins_per_month || body.coins || 0,
    discount_percentage: body.discount_percentage || body.discount || 0,
    description: body.description || "Verified badge subscription pricing",
    is_active: body.is_active !== undefined ? body.is_active : true,
  };
  const response = await customAxios.post(`/admin/verified-badge/settings/create`, createData);
  return response;
};

const updateVerifiedBadgeSettings = async (settingsId, body) => {
  const updateData = {
    coins_per_month: body.coins_per_month || body.coins || 0,
    discount_percentage: body.discount_percentage || body.discount || 0,
    description: body.description || "Verified badge subscription pricing",
    is_active: body.is_active !== undefined ? body.is_active : true,
  };
  const response = await customAxios.post(`/admin/verified-badge/settings/${settingsId}/update`, updateData);
  return response;
};

const VerificationBadgeService = {
  getVerifiedBadgeSettings,
  createVerifiedBadgeSettings,
  updateVerifiedBadgeSettings,
  manageVerificationBadge,
  getVerificationBadgeRequests,
  approveRejectVerificationBadge,
};

export default VerificationBadgeService;
